// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';

// Model imports
import { APCreditApplicationParameterDto } from '../../_models/accounts-payable/ap-credit-application/ap-credit-application-parameter-dto';
import { APCreditApplicationResultDto } from '../../_models/accounts-payable/ap-credit-application/ap-credit-application-result-dto';
import { APCreditApplicationUnapplyParametersDto } from '../../_models/accounts-payable/ap-credit-application/ap-credit-application-unapply-parameter-dto';

@Injectable({
    providedIn: 'root'
})
export class APCreditApplicationsService {
    constructor(private readonly httpClient: HttpClient) {}

    getAPCreditApplications(param: APCreditApplicationParameterDto): Observable<APCreditApplicationResultDto[]> {
        const url = `${URLConstants.ccCBAPBaseApiUrl}/creditapplication${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(APCreditApplicationResultDto, response)));
    }

    unapplyAPCreditApplication(param: APCreditApplicationUnapplyParametersDto): Observable<any> {
        const url = `${URLConstants.ccCBAPBaseApiUrl}/creditapplication/unapply`;
        return this.httpClient.put(url, classToPlain(param));
    }
}
